import { ApolloClient, InMemoryCache } from "@apollo/client";
import {
  GET_PRESIGNED_URLS_QUERY,
  GET_LIBRARY_CARD_QUERY,
  LIST_LIBRARY_CARDS_QUERY,
  SAVE_LIBRARY_CARD_MUTATION,
  PUT_FILE_EVENT_MUTATION,
} from "../queries/libraryCardQueries";

import { GET_LIBRARY_CARD_INDEX_TAGS_QUERY } from "../queries/getLibraryCardIndexTagsQuery";

const GRAPHQL_ENDPOINT =
  "https://m2jxbyhagffjthxtsiuwb2iiwe.appsync-api.us-east-1.amazonaws.com/graphql";

const client = new ApolloClient({
  uri: GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
  headers: {
    "x-api-key": "da2-xpdryjglfzcfxdupd4oqromo7y",
  },
});

export const fetchLibraryCardFromApi = async (input) => {
  try {
    console.log(
      `PMM - SF - libraryCardApi.js - fetchLibraryCardFromApi - input is: ${JSON.stringify(
        input
      )}`
    );
    const apiPayload = {
      query: GET_LIBRARY_CARD_QUERY,
      variables: { input },
    };
    console.log(
      `PMM - SF - libraryCardApi.js - fetchLibraryCardFromApi - apiPayload is: ${JSON.stringify(
        apiPayload
      )}`
    );
    const response = await client.query(apiPayload);

    console.log(
      `PMM - SF - libraryCardApi.js - Full response: ${JSON.stringify(
        response
      )}`
    );
    console.log(
      `PMM - SF - libraryCardApi.js - response.data: ${JSON.stringify(
        response?.data
      )}`
    );
    console.log(
      `PMM - SF - libraryCardApi.js - response.data.getLibraryCard: ${JSON.stringify(
        response?.data?.getLibraryCard
      )}`
    );
    console.log(
      `PMM - SF - libraryCardApi.js - response?.data?.getLibraryCard?.data is: ${JSON.stringify(
        response?.data?.getLibraryCard?.data
      )}`
    );
    const result = response?.data?.getLibraryCard?.data;
    console.log(
      `PMM - SF - libraryCardApi.js - Returning result: ${JSON.stringify(
        result
      )}`
    );
    return result;
  } catch (error) {
    console.log(
      `PMM - SF - libraryCardApiljs - error is: ${JSON.stringify(error)}`
    );
  }
};

export const listLibraryCardsFromApi = async (input) => {
  console.log(
    `PMM - SF - libraryCardApi.js - listLibraryCardsFromApi - input is: ${JSON.stringify(
      input
    )}`
  );
  const apiPayload = {
    query: LIST_LIBRARY_CARDS_QUERY,
    variables: { input },
  };
  console.log(
    `PMM - SF - libraryCardApi.js - listLibraryCardsFromApi - apiPayload is: ${JSON.stringify(
      apiPayload
    )}`
  );
  const response = await client.query(apiPayload);
  return response.data.listLibraryCards;
};

export const saveLibraryCardToApi = async (input) => {
  console.log(
    `PMM - SF - libraryCardApi.js - saveLibraryCardToApi - input is: ${JSON.stringify(
      input
    )}`
  );
  const apiPayload = {
    mutation: SAVE_LIBRARY_CARD_MUTATION,
    variables: { input },
  };

  console.log(
    `PMM - SF - libraryCardApi.js - saveLibraryCardToApi - apiPayload is: ${JSON.stringify(
      apiPayload
    )}`
  );
  const response = await client.mutate(apiPayload);
  // console.log(
  //   `PMM - SF - libraryCardApi.js - saveLibraryCardToApi - response is: ${JSON.stringify(
  //     response
  //   )}`
  // );
  return response;
};

export const createLibraryCardInApi = saveLibraryCardToApi;
export const updateLibraryCardInApi = saveLibraryCardToApi;

export const deleteLibraryCardFromApi = async (input) => {
  console.log("deleteLibraryCardFromApi not implemented yet");
  throw new Error("deleteLibraryCardFromApi not implemented yet");
};

export const fetchPresignedUrlsFromApi = async (actionPayload) => {
  actionPayload.operationType = "GET_PRESIGNED_URLS";

  // console.log(
  //   `PMM - SF - libraryCardApi.js - fetchPresignedUrlsFromApi - actionPayload is: ${JSON.stringify(
  //     actionPayload
  //   )}`
  // );

  const apiPayload = {
    query: GET_PRESIGNED_URLS_QUERY,
    variables: {
      input: actionPayload,
    },
  };

  const response = await client.query(apiPayload);
  return response.data.getPresignedUrls.presignedUrls;
};

export const putFileEventToApi = async (input) => {
  const apiPayload = {
    mutation: PUT_FILE_EVENT_MUTATION,
    variables: { input },
  };
  const response = await client.mutate(apiPayload);
  return response.data.putFileEvent;
};

export const uploadFileToApi = putFileEventToApi;

export const fetchMetadataFromApi = async (input) => {
  console.log("fetchMetadataFromApi not implemented yet");
  throw new Error("fetchMetadataFromApi not implemented yet");
};

export const fetchLibraryCardDetailsFromApi = fetchLibraryCardFromApi;

export const fetchLibraryCardsFromApi = async (input) => {
  console.log(
    `PMM - SF - api - fetchLibraryCardsFromApi - input: ${JSON.stringify(
      input
    )}`
  );

  try {
    const apiPayload = {
      query: LIST_LIBRARY_CARDS_QUERY, // This uses the list query
      variables: { input },
    };
    const response = await client.query(apiPayload);
    // console.log(
    //   `PMM - SF - libraryCardApi.js - fetchLibraryCardsFromApi - response: ${JSON.stringify(
    //     response
    //   )}`
    // );
    return response.data.listLibraryCards;
  } catch (error) {
    console.error(
      "PMM - SF - libraryCardApi.js - fetchLibraryCardsFromApi - error:",
      error
    );
    throw error;
  }
};

export const getLibraryCardTagsApi = async (payload) => {
  // console.log(
  //   `PMM - SF - libraryCardApi.js - getTagsApi payload is: ${JSON.stringify(
  //     payload
  //   )}`
  // );

  try {
    const response = await client.query({
      query: GET_LIBRARY_CARD_INDEX_TAGS_QUERY, // Use the GraphQL query to fetch media index tags
      variables: { input: payload },
    });

    // console.log(
    //   `PMM - SF - libraryCardApi.js - getLibraryCardTagsApi response is: ${JSON.stringify(
    //     response
    //   )}`
    // );
    return response;
  } catch (error) {
    console.error(
      `PMM - SF - libraryCardApi.js - Error fetching tags: ${error.message}`
    );
    throw error;
  }
};
